"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleGalleryVideoAsset = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mux_video_react_1 = __importDefault(require("@mux/mux-video-react"));
const TitleGalleryVideoAsset = ({ asset, isPlaying }) => {
    const videoRef = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        if (isPlaying) {
            videoRef.current.play();
        }
        else {
            videoRef.current.pause();
        }
    }, [isPlaying]);
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsx)(mux_video_react_1.default, { ref: videoRef, style: { maxWidth: '100%' }, playbackId: asset.muxPublicPlaybackId, metadata: {
            video_id: String(asset.id),
            video_title: asset.filename,
        }, 
        // @ts-ignore
        autoPlay: false, envKey: process.env.MUX_VIDEO_TRACK_KEY, 
        // @ts-ignore
        streamType: "on-demand", controls: false, height: "100%", loop: true, muted: true }));
};
exports.TitleGalleryVideoAsset = TitleGalleryVideoAsset;
